import { render, staticRenderFns } from "./editgroupnotes.vue?vue&type=template&id=bd6c053a&scoped=true"
import script from "./editgroupnotes.vue?vue&type=script&lang=ts"
export * from "./editgroupnotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6c053a",
  null
  
)

export default component.exports